import { useEffect } from "react";

/**
 * Google Tag Manager Integration
 *
 * Injects the GTM script (head) and noscript iframe (body) in production.
 * Replace the default gtmId prop with your real GTM container ID.
 *
 * Get your GTM ID at: https://tagmanager.google.com/
 * -> Container -> Admin -> Container Settings -> Container ID (e.g. GTM-XXXXXXX)
 *
 * Usage:
 *   <GoogleTagManager gtmId="GTM-ABC1234" />
 */

// ----- REPLACE WITH YOUR REAL GTM CONTAINER ID -----
const DEFAULT_GTM_ID = "GTM-XXXXXXX";
// ----------------------------------------------------

const GoogleTagManager = ({ gtmId = DEFAULT_GTM_ID }) => {
  useEffect(() => {
    // Only load in production
    if (process.env.NODE_ENV !== "production") return;

    // Avoid duplicate injection
    if (document.getElementById("gtm-script")) return;

    // ---- GTM head script ----
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById("gtm-script");
      if (existing) existing.remove();
    };
  }, [gtmId]);

  // Only render noscript fallback in production
  if (process.env.NODE_ENV !== "production") return null;

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="Google Tag Manager"
      />
    </noscript>
  );
};

export default GoogleTagManager;
